<template>
  <header>
    <!-- BACKDROP -->
    <div v-if="showBackdrop" class="notif-backdrop" @click="onBackdropClick"></div>
  
    <nav class="navbar custom-navbar shadow-sm" :class="{ 'nav-elevated': showBackdrop }">
      <div class="container-fluid d-flex align-items-center">
        <!-- SIDEBAR TOGGLE -->
        <button class="btn d-flex align-items-center custom-btn" type="button" data-bs-toggle="offcanvas"
          data-bs-target="#sidebar" aria-controls="sidebar">
          <i class="bi bi-list fs-3"></i>
        </button>
  
        <!-- APP TITLE -->
        <span class="fw-semibold ms-3 app-title">
          Monitoring Document - PT Fastana Logistik Indonesia
        </span>
  
        <!-- RIGHT MENU -->
        <div class="ms-auto d-flex align-items-center">
          <!-- NOTIFICATION -->
          <div class="dropdown me-3">
            <button ref="notifButton" class="btn position-relative custom-btn" type="button" data-bs-toggle="dropdown"
              aria-expanded="false" @click="loadNotifications">
              <i class="bi bi-bell fs-4" :class="{ 'bell-shake': hasAnyNotification }"></i>
              <span v-if="hasAnyNotification"
                class="position-absolute top-50 start-100 translate-middle badge rounded-pill bg-danger">
                {{ notificationBadgeCount }}
              </span>
            </button>
  
            <ul class="dropdown-menu dropdown-menu-end notification-dropdown">
              <li class="dropdown-header fw-bold d-flex justify-content-between align-items-center">
                <span><i class="bi bi-bell-fill me-1"></i> Notifikasi</span>
              </li>
  
              <li v-if="!hasAnyNotification">
                <span class="dropdown-item text-muted">Tidak ada notifikasi.</span>
              </li>
  
              <!-- Evaluasi -->
              <li v-if="evalNotifications.length > 0">
                <div class="dropdown-item-text">
                  <div class="fw-bold mb-2 small text-uppercase text-muted">Evaluasi Vendor</div>
                  <div v-for="item in evalNotifications" :key="'eval-' + item.id"
                    class="border rounded p-2 mb-2 notif-eval-item" role="button" @click="openEvalNotification(item)">
                    <div class="d-flex gap-2">
                      <i :class="evalIcon(item.type)" class="mt-1"></i>
                      <div class="flex-grow-1">
                        <div class="fw-semibold small">{{ item.title }}</div>
                        <div class="text-muted small" style="white-space: normal;">{{ item.message }}</div>
                        <div class="text-muted" style="font-size: 0.7rem;">{{ formatNotifTime(item.created_on) }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
  
              <!-- H-60 -->
              <li v-if="expiringList.length > 0">
                <div class="dropdown-item-text">
                  <div class="fw-bold mb-2">
                    <i class="bi bi-exclamation-triangle-fill text-warning me-2"></i>
                    Dokumen Mendekati Expired
                  </div>
                  <div class="text-muted mb-2">
                    <i class="bi bi-clock-history me-2"></i>
                    ≤ 60 Hari · {{ expiringList.length }} item
                  </div>
                  <div class="border rounded p-2 mb-2">
                    <div class="d-flex justify-content-between align-items-center mb-2" v-if="canViewDocument">
                      <div>
                        <i class="bi bi-file-earmark-text text-primary me-2"></i>
                        SPK
                      </div>
                      <strong class="text-primary">{{ totalSpk }}</strong>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-2" v-if="canViewDocument">
                      <div>
                        <i class="bi bi-file-earmark-text text-primary me-2"></i>
                        PKS
                      </div>
                      <strong class="text-primary">{{ totalPks }}</strong>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-2" v-if="canViewOffer">
                      <div>
                        <i class="bi bi-file-earmark-ruled text-info me-2"></i>
                        Penawaran Harga
                      </div>
                      <strong class="text-info">{{ totalTransportOffer }}</strong>
                    </div>
                    <div class="d-flex justify-content-between align-items-center" v-if="canViewAsset">
                      <div>
                        <i class="bi bi-pc-display text-success me-2"></i>
                        Asset IT
                      </div>
                      <strong class="text-success">{{ totalAsset }}</strong>
                    </div>
                  </div>
                  <button class="btn-icon-hover icon-primary w-100" @click="goDetail">
                    <span>Lihat Detail</span>
                  </button>
                </div>
              </li>
            </ul>
          </div>
  
          <!-- PROFILE -->
          <div class="dropdown">
            <button class="btn dropdown-toggle d-flex align-items-center custom-btn" id="dropdownMenuButton1"
              data-bs-toggle="dropdown" aria-expanded="false">
              <img :src="profilePhoto" class="profile-avatar me-2" alt="Profile" @error="onAvatarError" />
              <span class="username-text">{{ username }}</span>
            </button>
  
            <ul class="dropdown-menu dropdown-menu-end profile-dropdown">
              <!-- Header -->
              <li>
                <h6 class="dropdown-header bg-dark text-white mb-0 rounded-top">
                  Profile
                </h6>
              </li>
  
              <!-- Username / Email -->
              <li>
                <div class="dropdown-item-text px-3 py-2">
                  <small class="text-muted d-block">Email</small>
                  <span class="text-primary">{{ email || username }}</span>
                  <small class="text-muted d-block">NIK</small>
                  <span class="text-primary">{{ nik }}</span>
                </div>
              </li>
  
              <li>
                <hr class="dropdown-divider my-1" />
              </li>
  
              <!-- Daftar Aplikasi -->
              <li v-for="(item, i) in menus" :key="i">
                <button class="dropdown-item" @click="goToMenu(item.url)">
                  {{ item.menu_name }}
                </button>
              </li>
  
              <li>
                <hr class="dropdown-divider my-1" />
              </li>
  
              <!-- Logout -->
              <li>
                <button class="dropdown-item text-danger" @click="logout">
                  <i class="bi bi-box-arrow-right me-2"></i>
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import HeaderJs from "./header";

export default HeaderJs;
</script>

<style scoped>
.profile-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.35);
}

.notif-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

.nav-elevated {
  position: relative;
  z-index: 1050 !important;
}

/* Bell animation */
.bell-shake {
  display: inline-block;
  transform-origin: top center;
  animation: bellShake 2.5s ease-in-out infinite;
}

@keyframes bellShake {

  0%,
  40%,
  100% {
    transform: rotate(0deg);
  }

  5% {
    transform: rotate(15deg);
  }

  10% {
    transform: rotate(-13deg);
  }

  15% {
    transform: rotate(11deg);
  }

  20% {
    transform: rotate(-9deg);
  }

  25% {
    transform: rotate(7deg);
  }

  30% {
    transform: rotate(-5deg);
  }

  35% {
    transform: rotate(3deg);
  }

}

@media (max-width: 480px) {
  .username-text {
    display: none;
  }
}

/* Profile dropdown */
.profile-dropdown {
  min-width: 240px;
  padding-top: 0;
  max-height: 70vh;
  overflow-y: auto;
}

.profile-dropdown .dropdown-header {
  font-weight: 600;
  font-size: 0.95rem;
}

.profile-dropdown .dropdown-item {
  font-size: 0.9rem;
  padding: 0.45rem 1rem;
}

.profile-dropdown .dropdown-item:hover {
  background-color: #f1f3f5;
}

.profile-dropdown .text-danger:hover {
  background-color: #fff5f5;
  color: #dc3545 !important;
}

.notif-eval-item {
  cursor: pointer;
}

.notif-eval-item:hover {
  background: #f8f9fa;
}
</style>